import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailMailgunEachDirective } from '../../directives/email-mailgun-each.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import type { CampaignContractSubmittedTemplateTemplateData } from '../../templates/campaign-contract-submitted-template/campaign-contract-submitted-template.component';
import { EmailButtonComponent } from '../email-button/email-button.component';
import { EmailMarginComponent } from '../email-margin/email-margin.component';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  selector: 'email-campaign-contract-submitted',
  styleUrls: ['./email-campaign-contract-submitted.component.less'],
  template: `
    <email-text [contents]="data.order_summary" size="medium" [bold]="true" />
    <table cellspacing="0" cellpadding="0" class="products">
      <ng-container *mailgunFor="let product of data.products">
        <tr>
          <td align="left" class="product-cell">
            <li><email-text [contents]="product.title" className="product-title" /></li>
          </td>
        </tr>
      </ng-container>

      <tr>
        <td colspan="3" height="28">&nbsp;</td>
      </tr>
      <tr>
        <td colspan="3">
          <hr />
        </td>
      </tr>
      <tr>
        <td colspan="3" height="28">&nbsp;</td>
      </tr>
    </table>

    <email-text [contents]="data.body" size="medium" />
    <email-margin [height]="20" />
    <email-button [href]="data.primary_cta.href" [label]="data.primary_cta.label" theme="primary" />
  `,
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  imports: [
    EmailMarginComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailMailgunEachDirective,
  ],
})
export class EmailCampaignContractSubmittedComponent {
  @Input() public data: WrappedValue<CampaignContractSubmittedTemplateTemplateData>;
}
